// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_UploadAttributePhotoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/upload_attribute_photo
 *
 * Returns the uploaded photo URL and thumbnail URL for a laudo
 * report attribute.
 *
 * `url` is what the frontend STORES in the attribute value (unsigned).
 * `preview_url` is what it SHOWS: the same blob with a 1 h read SAS, so the
 * preview still opens once the `laudos` container is private (DS 2026-0043).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_UploadAttributePhotoResponseDados {
url: string
thumbnail_url: string
preview_url: string
}

export type Orders_UploadAttributePhotoResponse = ApiResponse<Orders_UploadAttributePhotoResponseDados>;

registerResponseContract('Orders_UploadAttributePhotoResponse', {
  url:           { type: 'string',  required: true },
  thumbnail_url: { type: 'string',  required: true },
  preview_url:   { type: 'string',  required: true },
})
